import { render, staticRenderFns } from "./Guia_Remision.vue?vue&type=template&id=2cdc0edc&scoped=true"
import script from "./Guia_Remision.vue?vue&type=script&lang=js"
export * from "./Guia_Remision.vue?vue&type=script&lang=js"
import style0 from "./Guia_Remision.vue?vue&type=style&index=0&id=2cdc0edc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdc0edc",
  null
  
)

export default component.exports